import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';

  const Home = () => {
  const { setUserInfo } = useUser();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const url = 'http://24.152.36.57:3000';

  const handleLogin = async (e) => {
    e.preventDefault();
    
    try {
      const upperUsername = username.toUpperCase();
    
      if (!upperUsername || !password) {
        alert('Por favor, preencha todos os campos.');
        return;
      }
    
      const response = await fetch(url + '/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password, username })
      });
    
      if (response.ok) {
        // Leia o JSON da resposta apenas uma vez
        const data = await response.json();
        //console.log('Dados recebidos:', data);
    
      // Verifica se a resposta é um array e contém objetos
      if (Array.isArray(data) && data.length > 0 && data[0].LOGIN) {
        if (data[0].LOGIN === "Login realizado com sucesso!") {
          setUserInfo({
            username: data[0].NOME,
            id: data[0].VEN_ID,
            company: "Wen System",
            url: url,
          });
          navigate('/menu');
        } else {
          alert('Login falhou. Por favor, verifique suas credenciais.');
        }
      } else {
        console.error('Estrutura de resposta inesperada:', data);
        alert('Login ou senha inexistente. Por favor, tente novamente.');
      }
    
      } else {
        // Para respostas com erro, capture o texto (não como JSON)
        //const errorText = await response.text();
        //console.error('Erro no login:', response.status, errorText);
        alert('Falha ao fazer login. Por favor, tente novamente.');
      }
    
    } catch (error) {
      //onsole.error('Erro ao fazer login:', error);
      alert('Ocorreu um erro ao fazer login. Por favor, tente novamente.');
    }    
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
      <img src="https://wensystem.com.br/wp-content/uploads/elementor/thumbs/wen-p623lz4kkweo04kemh8w9xxnnnil4y52p7qm1kzev8-q2udnzzadgwf28zy01to57p9qt3p3g9kjh2rvsjzzc.png" alt="Logo" style={{ marginBottom: '20px' }} />
      <h1>Login</h1>
      <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', width: '300px' }}>
        <input
          type="text"
          placeholder="Nome do Usuário"
          value={username}
          autoComplete='username'
          onChange={(e) => setUsername(e.target.value.toUpperCase())}
          required
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          autoComplete='current-password'
          onChange={(e) => setPassword(e.target.value.toUpperCase())}
          required
          style={inputStyle}
        />
        <button type="submit" style={buttonStyle}>Login</button>
      </form>
    </div>
  );
};

const inputStyle = {
  padding: '10px',
  margin: '10px 0',
  border: '1px solid #ccc',
  borderRadius: '4px',
};

const buttonStyle = {
  padding: '10px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export default Home;